document.addEventListener('CartDrawer:open', function(){
  $('.se-cart-reassurance__carousel').slick('refresh');

  setTimeout(() => { 
    $('.se-cart-carousel-wrapper').addClass('se-opened');
  }, 200);
});

$('.se-cart-reassurance__carousel').slick({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 2,
  prevArrow: '<div class="se-arrow-left"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>',
  nextArrow: '<div class="se-arrow-right"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
});